import { createAction, createActions, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as codeApi from '../lib/api/commonCode';

const [LIST_CODES, LIST_CODES_SUCCESS, LIST_CODES_FAILURE] =
  createRequestActionTypes('comCode/LIST_CODES');

const [ADD_CODE, ADD_CODE_SUCCESS, ADD_CODE_FAILURE] =
  createRequestActionTypes('comCode/ADD_CODE');
const CLEAN_CODES = 'comCode/CLEAN_CODES';

export const listCodes = createAction(LIST_CODES, (searchData) => searchData);
export const addCode = createAction(ADD_CODE, (dataToSubmit) => dataToSubmit);
export const cleanCodes = createActions(CLEAN_CODES);

const listCodesSaga = createRequestSaga(LIST_CODES, codeApi.getComCodes);
const addCodeSaga = createRequestSaga(ADD_CODE, codeApi.addComCode);

export function* comCodeSaga() {
  yield takeLatest(LIST_CODES, listCodesSaga);
  yield takeLatest(ADD_CODE, addCodeSaga);
}

const initialState = {
  comCodes: null,
  saveResult: null,
  listError: null,
  saveError: null,
};

const comCode = handleActions(
  {
    [LIST_CODES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      comCodes: data.list.map((code) => ({
        id: code.commonUuid,
        blcCd: code.blcCd,
        mlcCd: code.mlcCd,
        slcCd: code.slcCd,
        itemNm: code.itemNm,
        itemDesc: code.itemDesc,
        revVal1: code.revVal1,
        revVal2: code.revVal2,
        step:code.step,
        useYn: code.useYn === 'Y' ? true : false,
        crtNm: code.crtNm,
        crtTm: code.crtTm,
        cngNm: code.cngNm,
        cngTm: code.cngTm,
      })),
      listError: null,
    }),
    [LIST_CODES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      listError: error,
    }),
    [ADD_CODE]: (state) => ({
      ...state,
      //code와 error초기화
      saveResult: null,
      saveError: null,
    }),
    [ADD_CODE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      saveResult: data,
    }),
    [ADD_CODE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      saveError: error,
      saveResult: null,
    }),
    [CLEAN_CODES]: (state) => ({
      ...state,
      comCodes: null,
      saveResult: null,
      listError: null,
      saveError: null,
    }),
  },
  initialState,
);

export default comCode;
